import { _toUnsigned, _toSigned16 } from './../utils';
export class _HuffmanTree {
    _load(code) {
        this._clArray = code;
        this._initialize();
    }
    _loadTree(isLengthTree) {
        this._clArray = isLengthTree ? this._getLengthTree() : this._getDepthTree();
        this._initialize();
    }
    _initialize() {
        if (this._clArray.length === _HuffmanTree._maxLengthTree) {
            this._tBits = 9;
        }
        else {
            this._tBits = 7;
        }
        this._tMask = (1 << this._tBits) - 1;
        this._createTable();
    }
    _getLengthTree() {
        const lTree = Array(_HuffmanTree._maxLengthTree).fill(0);
        for (let i = 0; i <= 143; i++) {
            lTree[i] = _toUnsigned(8, 8);
        }
        for (let i = 144; i <= 255; i++) {
            lTree[i] = _toUnsigned(9, 8);
        }
        for (let i = 256; i <= 279; i++) {
            lTree[i] = _toUnsigned(7, 8);
        }
        for (let i = 280; i <= 287; i++) {
            lTree[i] = _toUnsigned(8, 8);
        }
        return lTree;
    }
    _getDepthTree() {
        return Array(_HuffmanTree._maxDepthTree).fill(5);
    }
    _calculateHashCode() {
        const bit = Array(17).fill(0);
        for (let i = 0; i < this._clArray.length; i++) {
            bit[this._clArray[i]]++;
        }
        bit[0] = 0;
        const next = Array(17).fill(0);
        let temp = 0;
        for (let bits = 1; bits <= 16; bits++) {
            temp = (temp + bit[bits - 1]) << 1;
            next[bits] = temp;
        }
        const code = Array(_HuffmanTree._maxLengthTree).fill(0);
        for (let i = 0; i < this._clArray.length; i++) {
            const len = this._clArray[i];
            if (len > 0) {
                code[i] = this._bitReverse(next[len], len);
                next[len]++;
            }
        }
        return code;
    }
    _bitReverse(code, length) {
        let newcode = 0;
        do {
            newcode |= code & 1;
            newcode <<= 1;
            code >>= 1;
        } while (--length > 0);
        return newcode >> 1;
    }
    _createTable() {
        const codeArray = this._calculateHashCode();
        this._table = Array(1 << this._tBits).fill(0);
        this._left = Array(2 * this._clArray.length).fill(0);
        this._right = Array(2 * this._clArray.length).fill(0);
        let avail = _toSigned16(this._clArray.length);
        for (let ch = 0; ch < this._clArray.length; ch++) {
            const len = this._clArray[ch];
            if (len > 0) {
                let start = codeArray[ch];
                if (len <= this._tBits) {
                    const i = 1 << len;
                    if (start >= i) {
                        throw new Error('Invalid Data.');
                    }
                    const l = 1 << (this._tBits - len);
                    for (let j = 0; j < l; j++) {
                        this._table[start] = _toSigned16(ch);
                        start += i;
                    }
                }
                else {
                    let ofBits = len - this._tBits;
                    let bitMask = 1 << this._tBits;
                    let index = start & ((1 << this._tBits) - 1);
                    let array = this._table;
                    do {
                        let value = _toSigned16(array[index]);
                        if (value === 0) {
                            array[index] = _toSigned16(-avail);
                            value = _toSigned16(-avail);
                            avail++;
                        }
                        if (value > 0) {
                            throw new Error('Invalid Data.');
                        }
                        if ((start & bitMask) === 0) {
                            array = this._left;
                        }
                        else {
                            array = this._right;
                        }
                        index = -value;
                        bitMask <<= 1;
                        ofBits--;
                    } while (ofBits !== 0);
                    array[index] = _toSigned16(ch);
                }
            }
        }
    }
    _getNextSymbol(input) {
        const bitBuffer = input._load16Bits();
        if (input._bInBuffer === 0) {
            return -1;
        }
        let symbol = this._table[bitBuffer & this._tMask];
        if (symbol < 0) {
            let mask = _toUnsigned((1 << this._tBits), 32);
            do {
                symbol = -symbol;
                if ((bitBuffer & mask) === 0) {
                    symbol = this._left[symbol];
                }
                else {
                    symbol = this._right[symbol];
                }
                mask <<= 1;
            } while (symbol < 0);
        }
        const codeLength = this._clArray[symbol];
        if (codeLength <= 0) {
            throw new Error('Invalid Data.');
        }
        if (codeLength > input._bInBuffer) {
            return -1;
        }
        input._skipBits(codeLength);
        return symbol;
    }
}
_HuffmanTree._maxLengthTree = 288;
_HuffmanTree._maxDepthTree = 32;
_HuffmanTree._nCLength = 19;
